import { useTranslation } from 'react-i18next';

import TitleQuotation from '../../components/title-quotation';
import Hr from '../../components/Style/hr';
import PersonnalAndAddressForm from '../../components/Forms/personnal-and-address-form';

export default function StepPersonnalInfosForm({ returnedData, initialFormData }) {
    const { t } = useTranslation();

    const handleReturnedData = (data) => {
        returnedData(data);
    };

    return (
        <>
            <TitleQuotation title={t('pageServices.step2.welcomeMessage')} description={t('pageServices.step2.description')} step="2" />
            <Hr />
            <PersonnalAndAddressForm returnedData={handleReturnedData} initialFormData={initialFormData} />
        </>
    );
}